/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { TEnterChannelNumberState } from './enterchannelnumber.props';
import {
    GUIDE_SET_ENTERED_CHANNEL_NUMBER,
    START_ENTER_CHANNEL_NUMBER,
    STOP_ENTER_CHANNEL_NUMBER,
} from './enterchannelnumber.types';

export const startEnterChannelNumberAction = (): TivoPayloadAction<
    Partial<TEnterChannelNumberState>
> => ({
    type: START_ENTER_CHANNEL_NUMBER,
    payload: {
        isEnterChannelNumberActive: true,
        enteredChannelNumber: '',
    },
});

export const stopEnterChannelNumberAction = (): TivoPayloadAction<
    Partial<TEnterChannelNumberState>
> => ({
    type: STOP_ENTER_CHANNEL_NUMBER,
    payload: {
        isEnterChannelNumberActive: false,
        enteredChannelNumber: '',
    },
});

export const setEnteredChannelNumberAction = (
    enteredChannelNumber: string,
): TivoPayloadAction<Partial<TEnterChannelNumberState>> => ({
    type: GUIDE_SET_ENTERED_CHANNEL_NUMBER,
    payload: {
        enteredChannelNumber,
    },
});
